import { render, staticRenderFns } from "./elevator.vue?vue&type=template&id=c01f820e"
import script from "./elevator.vue?vue&type=script&lang=js"
export * from "./elevator.vue?vue&type=script&lang=js"
import style0 from "./elevator.vue?vue&type=style&index=0&id=c01f820e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports